import { getLoyaltyWallet, generateLoyaltyPromoCode } from '../../util/api';
import { storableError } from '../../util/errors';

// ─── Action types ──────────────────────────────────────────────────────────────

const FETCH_WALLET_REQUEST = 'app/CagnotteFidelitePage/FETCH_WALLET_REQUEST';
const FETCH_WALLET_SUCCESS = 'app/CagnotteFidelitePage/FETCH_WALLET_SUCCESS';
const FETCH_WALLET_ERROR = 'app/CagnotteFidelitePage/FETCH_WALLET_ERROR';

const GENERATE_CODE_REQUEST = 'app/CagnotteFidelitePage/GENERATE_CODE_REQUEST';
const GENERATE_CODE_SUCCESS = 'app/CagnotteFidelitePage/GENERATE_CODE_SUCCESS';
const GENERATE_CODE_ERROR = 'app/CagnotteFidelitePage/GENERATE_CODE_ERROR';

// ─── Reducer ───────────────────────────────────────────────────────────────────

const initialState = {
  wallet: null,
  fetchWalletInProgress: false,
  fetchWalletError: null,
  generateCodeInProgress: false,
  generateCodeError: null,
  generatedCode: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_WALLET_REQUEST:
      return { ...state, fetchWalletInProgress: true, fetchWalletError: null };
    case FETCH_WALLET_SUCCESS:
      return { ...state, fetchWalletInProgress: false, wallet: payload };
    case FETCH_WALLET_ERROR:
      return { ...state, fetchWalletInProgress: false, fetchWalletError: payload };

    case GENERATE_CODE_REQUEST:
      return { ...state, generateCodeInProgress: true, generateCodeError: null };
    case GENERATE_CODE_SUCCESS:
      return {
        ...state,
        generateCodeInProgress: false,
        generatedCode: payload,
        // Refresh wallet data optimistically: decrement nothing here – wallet will be re-fetched
      };
    case GENERATE_CODE_ERROR:
      return { ...state, generateCodeInProgress: false, generateCodeError: payload };

    default:
      return state;
  }
}

// ─── Action creators ───────────────────────────────────────────────────────────

const fetchWalletRequest = () => ({ type: FETCH_WALLET_REQUEST });
const fetchWalletSuccess = wallet => ({ type: FETCH_WALLET_SUCCESS, payload: wallet });
const fetchWalletError = e => ({ type: FETCH_WALLET_ERROR, payload: e, error: true });

const generateCodeRequest = () => ({ type: GENERATE_CODE_REQUEST });
const generateCodeSuccess = data => ({ type: GENERATE_CODE_SUCCESS, payload: data });
const generateCodeError = e => ({ type: GENERATE_CODE_ERROR, payload: e, error: true });

// ─── Thunks ────────────────────────────────────────────────────────────────────

export const fetchWallet = () => dispatch => {
  dispatch(fetchWalletRequest());
  return getLoyaltyWallet()
    .then(data => dispatch(fetchWalletSuccess(data)))
    .catch(e => dispatch(fetchWalletError(storableError(e))));
};

export const generateCode = () => dispatch => {
  dispatch(generateCodeRequest());
  return generateLoyaltyPromoCode()
    .then(data => {
      dispatch(generateCodeSuccess(data));
      // Re-fetch wallet to get updated state
      dispatch(fetchWallet());
      return data;
    })
    .catch(e => dispatch(generateCodeError(storableError(e))));
};

// ─── loadData for SSR ──────────────────────────────────────────────────────────

export const loadData = () => dispatch => {
  return dispatch(fetchWallet());
};
